export default __webpack_public_path__ + "static/media/campus (4).ed5bbedd.jpg";